export class CalendarFechaNacParametros {
    es: any = {
            firstDayOfWeek: 1,
            dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
            dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
            monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
            monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
        };
    yearRange: string;
    maxDate:Date;
    minDate:Date;
    constructor(){
        let now = new Date(Date.now());
        let past = new Date(Date.now());
        past.setFullYear(past.getFullYear() - 100);
        this.yearRange = (now.getFullYear() - 100) + ":" + (now.getFullYear() - 18);
        this.maxDate = now;
        this.minDate = past;
    }
}

export class CalendarFechaNac {
    es: any = {
            firstDayOfWeek: 1,
            dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
            dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
            monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
            monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
        };
    yearRange: string;
    maxDate:Date;
    minDate:Date;
    constructor(){
        let now = new Date(Date.now());
        let past = new Date(Date.now());
        past.setFullYear(past.getFullYear() - 100);
        this.yearRange = (now.getFullYear() - 100) + ":" + now.getFullYear();
        this.maxDate = now;
        this.minDate = past;
    }
}

export class CalendarFec {
    es: any = {
            firstDayOfWeek: 1,
            dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
            dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
            monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
            monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
        };
    yearRange: string;
    maxDate:Date;
    minDate:Date;
    constructor(){
        let now = new Date(Date.now());
        let past = new Date(Date.now());
        past.setFullYear(past.getFullYear() - 1);
        this.yearRange = (now.getFullYear() - 1) + ":" + now.getFullYear();
        this.maxDate = now;
        this.minDate = past;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/utils/calendarFechaNacParametros.ts